import { AuditTab } from "@mikros/library/src/model";
import { createContext, useContext, useState, ReactNode } from "react";

interface AuditContextType {
  auditModel: any; // Replace 'any' with your actual audit model type
  setAuditModel: (data: any) => void;
  totalUserCount: number;
  setTotalUserCount: (count: number) => void;
  searchActive: boolean;
  setSearchActive: (active: boolean) => void;
  formData: any; // Replace 'any' with your actual form data type
  setFormData: (data: any) => void;
  hasMoreData: boolean;
  setHasMoreData: (hasMore: boolean) => void;
  auditNameSelected: string;
  setAuditNameSelected: (name: string) => void;
}

const AuditContext = createContext<AuditContextType | undefined>(undefined);

export function AuditContextProvider({ children }: { children: ReactNode }) {
  const [auditModel, setAuditModel] = useState<AuditTab>({
    audits: [],
    lastKey: null,
  });

  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [searchActive, setSearchActive] = useState(false);
  const [formData, setFormData] = useState({
    auditName: "",
    auditedBy: "",
    branchName: "",
    department: "",
    location: "",
    designation: "",
  });
  const [hasMoreData, setHasMoreData] = useState(true);
  const [auditNameSelected, setAuditNameSelected] = useState("");
  // const [userFetchModel, setUserFetchModel] = useState<any>(null);

  return (
    <AuditContext.Provider
      value={{
        auditModel,
        setAuditModel,
        totalUserCount,
        setTotalUserCount,
        searchActive,
        setSearchActive,
        formData,
        setFormData,
        hasMoreData,
        setHasMoreData,
        auditNameSelected,
        setAuditNameSelected,
      }}
    >
      {children}
    </AuditContext.Provider>
  );
}

export function useAudit() {
  const context = useContext(AuditContext);
  if (context === undefined) {
    throw new Error("useAudit must be used within an AuditProvider");
  }
  return context;
}
